import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const NewsPage = () => {
  const { t } = useTranslation();
  
  const newsLinks = [
    "https://customs.gov.mk/uvoz.nspx",
    "https://customs.gov.mk/izvoz.nspx",
    "https://customs.gov.mk/tranzit.nspx",
    "https://customs.gov.mk/poednostaveni-postapki.nspx",
    "https://customs.gov.mk/patnicki-vozila.nspx",
    "https://customs.gov.mk/akcizno-postapuvanje.nspx",
  ];

  const news = [
    t('news.news1'),
    t('news.news2'),
    t('news.news3'),
    t('news.news4'),
    t('news.news5'),
    t('news.news6'),
  ];

  const itemsPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(news.length / itemsPerPage);

  const handleScroll = (direction) => {
    if (direction === "left" && currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    } else if (direction === "right" && currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const renderPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageClick(i)}
            className={`mx-1 px-2 py-1 rounded ${
              currentPage === i ? "bg-[#F67E20] text-white" : "bg-white"
            }`}
          >
            {i}
          </button>
        );
      }
    } else {
      if (currentPage > 3) {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageClick(1)}
            className="mx-1 px-2 py-1 rounded"
          >
            1
          </button>
        );
        pages.push(<span key="left-ellipsis" className="mx-1">...</span>);
      }
      for (
        let i = Math.max(1, currentPage - 1);
        i <= Math.min(totalPages, currentPage + 1);
        i++
      ) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageClick(i)}
            className={`mx-1 px-2 py-1 rounded ${
              currentPage === i ? "bg-[#F67E20] text-white" : "bg-white"
            }`}
          >
            {i}
          </button>
        );
      }
      if (currentPage < totalPages - 2) {
        pages.push(<span key="right-ellipsis" className="mx-1">...</span>);
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageClick(totalPages)}
            className="mx-1 px-2 py-1 rounded bg-white"
          >
            {totalPages}
          </button>
        );
      }
    }
    return pages;
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentNews = news.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div className="px-5 max-w-[1290px] w-full mx-auto lg:mt-32 mt-24 mb-32">
      <h1 className="lg:text-[47.78px] text-[33.18px] leading-[39.82px] lg:leading-[57.34px] font-[900] mb-6">{t('news.title')}</h1>
      <p className="lg:text-[19.2px] text-[16px] lg:leading-[24.96px] leading-[20.8px] font-[400] text-[#3D3D3D] mb-28">
        {t('news.description')}
      </p>

      <div className="space-y-7">
        {currentNews.map((item, index) => (
          <div
            key={index}
            className="flex justify-between items-center border-b pb-8"
            style={{ borderColor: "#B0B0B0" }}
          >
            <p className="lg:leading-[24.96px] leading-[20.8px] font-[700] text-[16px] lg:text-[19.2px] text-[#000000] mr-10 sm:mr-8">
              {item}
            </p>
            <a
              href={newsLinks[index]}  
              target="_blank" rel="noopener noreferrer"  
              className="text-[#F67E20] flex items-center space-x-2 font-[700] text-[16px] leading-[20.8px]"
            >
              <span>{t('news.open')}</span>
              <i className="fa-solid fa-arrow-right"></i>
            </a>
          </div>
        ))}
      </div>

      <div className="flex justify-between items-center mt-20">
        <button
          onClick={() => handleScroll("left")}
          disabled={currentPage === 1}
          className="disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <img src="/images/ArrowLeft.jpg" alt="Previous" className="w-[32px] h-[32px]" />
        </button>

        <div className="flex">{renderPageNumbers()}</div>

        <button
          onClick={() => handleScroll("right")}
          disabled={currentPage === totalPages}
          className="disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <img src="/images/ArrowRight.jpg" alt="Next" className="w-[32px] h-[32px]" />
        </button>
      </div>
    </div>
  );
};

export default NewsPage;
